import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BasicApi from "../../../api/basic.api";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageForm from "../../../component/atoms/layout/detail/detailPageForm";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailFormText from "../../../component/atoms/text/detail/detailFormText";
import DetailFormTitle from "../../../component/atoms/text/detail/detailFormTitle";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";
import { route } from "../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import EditBtn from "../../../component/atoms/button/editBtn";
import TableTitle from "../../../component/atoms/text/table/tableTitle";
import FileImgPreview from "../../../component/molecules/fileImgPreview";

const Basic = () => {
  const navigate = useNavigate();
  const [basicInfo, setBasicInfo] = useState({
    companyName: "",
    ceo: "",
    businessNumber: "",
    address: "",
    tel: "",
    email: "",
  });

  const getBasicInfo = async () => {
    try {
      let responseData = (await BasicApi.getBasicInfo()).data.data.content;

      setBasicInfo(responseData);
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    getBasicInfo();
  }, []);

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <DetailPageLayout>
          <DetailTop>
            <TableTitle>기본 관리</TableTitle>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <EditBtn
                onClick={() => {
                  navigate(route.service_basic_edit);
                }}
              />
            </div>
          </DetailTop>

          <DetailPage>
            <DetailPageTitle>기본 관리</DetailPageTitle>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "20px" }}
            >
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>로고</DetailFormTitle>
                <FileImgPreview
                  fileName={basicInfo.logoOriginFileName}
                  serverFileName={basicInfo.logoServerFileName}
                />
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>상호명</DetailFormTitle>
                <DetailFormText>{basicInfo.companyName}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>대표</DetailFormTitle>
                <DetailFormText>{basicInfo.ceo}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>사업자등록번호</DetailFormTitle>
                <DetailFormText>{basicInfo.businessNumber}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>통신판매업신고번호</DetailFormTitle>
                <DetailFormText>{basicInfo.reportNumber}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>주소</DetailFormTitle>
                <DetailFormText>{basicInfo.address}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>TEL</DetailFormTitle>
                <DetailFormText>{basicInfo.tel}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>E-MAIL</DetailFormTitle>
                <DetailFormText>{basicInfo.email}</DetailFormText>
              </DetailPageForm>
              <DetailPageForm>
                <DetailFormTitle>구독 금액</DetailFormTitle>
                <DetailFormText>
                  {Number(basicInfo.membershipPrice || 0).toLocaleString()}원
                </DetailFormText>
              </DetailPageForm>
              <DetailPageForm style={{ alignItems: "flex-start" }}>
                <DetailFormTitle>CS CENTER</DetailFormTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <DetailFormText>{basicInfo.csCenter1}</DetailFormText>
                  <DetailFormText>{basicInfo.csCenter2}</DetailFormText>
                  <DetailFormText>{basicInfo.csCenter3}</DetailFormText>
                </div>
              </DetailPageForm>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default Basic;
